import {FormConfiguration} from "../../../advanced-form/form-configuration.type";
import {IssueStatus} from "../../../domain/entities/issue-status.entity";

export const issueStatusFormSettings: FormConfiguration<IssueStatus>[] = [
    {
        key: `key`,
        type: String,
        label: `Name`,
        initialValue: ``,
        validators: []
    },
    {
        key: `shortcut`,
        type: String,
        initialValue: ``,
        label: `Kürzel`,
        validators: []
    },
    {
        key: `color`,
        type: String,
        initialValue: `#FFFFFF`,
        validators: [],
        label: `Farbe`
    },
]
